'use strict';

let Form = require('../components/ajaxForm');

$(document).ready(function () {

    let $modal = $('#modalSendComparisonEmail');

    $('#sendComparisonEmail').on('click', function () {
        dataLayer.push({
            'event': 'ga.event',
            'eCategory': 'Elektřina',
            'eAction': 'Zobrazení-modal-email',
            'eLabel': '2-krok'
        });
    });

    let $form = $modal.find('form');
    let $formMsg = $form.find('.form-message');
    let $submitBtn = $form.find('button[type=submit]');

    $submitBtn.on('click', function (e) {
        e.preventDefault();
        let gtmData = {
            'event': 'ga.event',
            'eCategory': 'Elektřina',
            'eAction': 'Vyplnění-modal-email',
            'eLabel': '2-krok'
        };
        Form.ajaxSubmitForm($form, $formMsg, 'json', gtmData, function(){
            $form.find('button[type=submit]').attr('disabled', true);
        });
    });

});



// WEBPACK FOOTER //
// ./app/Resources/assets/js/scripts/modalSendComparisonEmail.js